import { useEffect, useState } from "react"
import { useQuery } from "@tanstack/react-query" 


const parseQueryParams = (queryParams):string => {
  let finalParams:string = ""
  if( !queryParams ) return ""
  if( typeof queryParams === "string" ){
    finalParams = queryParams
  } else if( typeof queryParams === "object" ){
    return `?${Object.keys(queryParams).reduce((acc:string[], key:string) => {
      if( queryParams[key] ){
        acc.push(`${key}=${queryParams[key]}`)
      }
      return acc
    }, []).join("&")}`
  }
  if( finalParams.length > 0 ){
    return `?${finalParams}`
  }
  console.log(finalParams)
  return finalParams
}

export function useGenericQuery({
  resource,
  qk,
  queryParams="",
  enabled,
  callback
}:{
  resource:string 
  qk:string[]
  queryParams?:any 
  enabled:boolean
  callback?:any
}){

  
  const [ queryParamsFinal, setQueryParamsFinal ] = useState<any>()
  const [ queryPrepared, setQueryPrepared ] = useState<boolean>(false)

  const queryEnabled = !!(enabled && queryPrepared)


  const query = useQuery({ 
    queryKey: qk, 
    enabled,
    queryFn: async () => {
      const result = await fetch(`/api/${resource}${parseQueryParams(queryParams)}`)
      const data = await result.json()
      console.log(data)
      if( data.status !== "success" ) throw new Error(data.msg)
      if( callback ) callback(data.payload)
      return data.payload
    }
  })

  // useEffect(() => {
  //   console.log("Query Params Changed", queryParams)
  //   if( queryParams ){
  //     setQueryPrepared(false)
  //     console.log(queryParams._sortby)
  //     const finalParams = parseQueryParams()
  //     console.log("Final Params", finalParams)
  //     setQueryParamsFinal(finalParams)
  //     setQueryPrepared(true)
  //   }
  // },[queryParams])

  return query
}